// extracted by mini-css-extract-plugin
export default {"detailsWrapper":"preview_detailsWrapper__yfjGe","iframeWrapper":"preview_iframeWrapper__IaUye","statSummary":"preview_statSummary__B4ZGp","item":"preview_item__5o7uy"};